
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[uid]",
      function () {
        return require("private-next-pages/info/[uid]/index.tsx");
      }
    ]);
  